<template>
    <div>
      <div class="action-buttons">
        <div class="left-buttons">
          <div class="col-md-12" style="margin-top: 15px;">
            <div class="form-group">
              <label>{{ $t('gestiune.locatie') }}</label>
              <select class="form-control" v-model="selectedLocation" :disabled="loading">
                <option :value="null">Selectează</option>
                <optgroup
                  v-for="group in groupedLocations"
                  :key="group.vat"
                  :label="`VAT: ${group.vat}`"
                >
                  <option
                    v-for="loc in group.locations"
                    :key="loc.id"
                    :value="loc"
                  >
                    {{ loc.name }}
                  </option>
                </optgroup>
              </select>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group" style="display: grid; margin-top: 15px;">
              <label>{{ $t('invoice.series') }}</label>
              <el-input :disabled="loading" v-model="filter.series" @input="onSeriesInput" ref="seriesInput" placeholder="Introdu seria facturii"></el-input>
            </div>
          </div>
          <div class="search-button-reports">
            <button
                :title="$t('reports.search')"
                class="btn add mar-rt-10"
                @click="onSearch"
            >
                <i class="ti-search"></i>
                <span>{{ $t('general.search') }}</span>
            </button>
          </div>
        </div>
         <div class="right-buttons">
            <button class="btn add mar-rt-10"  @click.prevent="addInvoice" :title="$t('general.add') + ' ' + $t('settingUsers.single')">
              <img src="/static/img/icons/add.png">
              {{$t('gestiune.addAviz')}}
            </button>
         </div>
      </div>
      <div class="card mar-to-15 tableInvoice">
          <div class="card-content">
            <div :class="(loading ? 'show-loader' : 'hide-loader')">
              <div class="el-loading-spinner">
                <svg viewBox="25 25 50 50" class="circular">
                  <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
                </svg><!---->
              </div>
            </div>
            <div class="data-table">
                <el-table :data="tableData" :empty-text="$t('gestiune.noData')" style="width: 100%;">
                    <el-table-column prop="invoiceNumber" :label="$t('invoice.invoice')"></el-table-column>
                    <el-table-column prop="series" :label="$t('invoice.series')"></el-table-column>
                    <el-table-column prop="client" :label="$t('invoice.client')"></el-table-column>
                    <el-table-column prop="issueDate" :label="$t('invoice.issueDate')" :formatter="formatDate"></el-table-column>
                    <el-table-column prop="valueNoVAT" :label="$t('invoice.valueNoVAT')"></el-table-column>
                    <el-table-column prop="vatValue" :label="$t('invoice.vatValue')"></el-table-column>
                    <el-table-column prop="totalValue" :label="$t('invoice.totalValue')"></el-table-column>
                    <el-table-column prop="status" :label="$t('invoice.status')"></el-table-column>
                    <el-table-column :label="$t('general.actions')" width="100">
                      <template slot-scope="scope">
                        <el-dropdown trigger="click" placement="bottom-end">
                          <!-- Trigger: sageata jos cu border violet -->
                          <span class="arrow-box">
                            &#9662; <!-- sageata jos -->
                          </span>
                          <el-dropdown-menu slot="dropdown" class="custom-dropdown-menu">
                            <el-dropdown-item @click.native="editInvoice(scope.row.invoiceNumber, scope.row.series)">
                              {{$t('general.edit')}}
                            </el-dropdown-item>
                            <el-dropdown-item @click.native="invoice(scope.row.invoiceNumber, scope.row.series)">
                              {{$t('invoice.invoiced')}}
                            </el-dropdown-item>
                            <el-dropdown-item @click.native="downloadInvoice(scope.row)">
                              {{$t('invoice.download')}}
                            </el-dropdown-item>
                            <el-dropdown-item @click.native="downloadExcel(scope.row)">
                              {{$t('gestiune.downloadExcel')}}
                            </el-dropdown-item>
                            <el-dropdown-item
                              :disabled="scope.$index !== 0"
                              @click.native="scope.$index === 0 && handleDeleteInvoice(scope.row.id)"
                              style="color: red; font-weight: bold;"
                            >
                              {{$t('general.delete')}}
                            </el-dropdown-item>
                          </el-dropdown-menu>
                        </el-dropdown>
                      </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                  layout="prev, pager, next"
                  :total="totalItems"
                  :page-size="pageSize"
                  :current-page="currentPage"
                  @current-change="handlePageChange"
                  style="margin-top: 15px; text-align: right;"
                ></el-pagination>
            </div>
           </div>
      </div>
    </div>
</template>

<script>
// import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
import swal from 'sweetalert2'

export default {
   // components: {
  //   GeneralTopBar
  // },
  data () {
    return {
      loading: false,
      loadingTimeout: null,
      tableData: [],
      allLocations: [],
      totalItems: 0,
      currentPage: 1,
      pageSize: 20,
      onSeriesInputTimeout: null,
      filter: {
        series: ''
      },
      selectedLocation: null,
      vatNumber: null
    }
  },
  props: {
    groupedLocations: {
      type: Array,
      required: true
    }
  },
  created () {
    this.companyID = this.$session.get('selectedCompany')

    this.$bus.$on('refresh', this.handleRefresh)
  },
  // mounted () {
  //   this.$bus.$on('refresh', this.handleRefresh)
  // },
  beforeDestroy () {
    this.$bus.$off('refresh', this.handleRefresh)
  },
  methods: {
    handleRefresh () {
      this.getInvoices(this.filter.series || '', 'aviz', { locations: this.allLocations })
    },
    onSearch () {
      // Validare locație
      if (!this.selectedLocation || (Array.isArray(this.selectedLocation) && this.selectedLocation.length === 0)) {
        swal({
          type: 'warning',
          title: this.$t('general.required'),
          text: 'Selectați cel puțin o locație',
          confirmButtonText: 'OK'
        })

        this.tableData = []
        this.totalItems = 0

        return
      }

      // Dacă toate sunt OK, faci fetch
      const locations = Array.isArray(this.selectedLocation) ? this.selectedLocation : [this.selectedLocation]
      this.getInvoices(this.filter.series || '', 'aviz', { locations })
    },
    handlePageChange (page) {
      this.currentPage = page
      this.getInvoices(this.filter.series || '', 'aviz', this.selectedLocation, this.currentPage, this.pageSize)
    },
    onSeriesInput (value) {
      this.filter.series = value
    },
    addInvoice () {
      this.$router.push('/management/outputs/add')
    },
    editInvoice (invoiceNumber, series) {
      if (!invoiceNumber || !series) {
        console.error('Missing invoice number or series')
        return
      }

      const invoiceId = `${series}-${invoiceNumber}`
      this.$router.push({
        path: `/management/outputs/${invoiceId}`,
        query: { edit: 'true' }
      })
    },
    invoice (invoiceNumber, series) {
      if (!invoiceNumber || !series) {
        console.error('Missing invoice number or series')
        return
      }

      const invoiceId = `${series}-${invoiceNumber}`
      this.$router.push(`/management/outputs/${invoiceId}`)
    },
    formatDate (row, column, cellValue) {
      if (!cellValue) return ''
      return new Date(cellValue).toLocaleDateString()
    },
    async getInvoices (series = '', tip = 'aviz', location = null, page = 1, pageSize = 25) {
      const externalCompanyId = this.companyID

      if (!externalCompanyId) {
        return
      }

      let url = `${process.env.API_BASE_URL_GESTIUNE}:4443/documents?externalCompanyId=${externalCompanyId}&tip=${tip}`
      if (series) {
        url += `&series=${series}`
      }

      url += `&page=${page}&limit=${pageSize}`

      if (location) {
        if (Array.isArray(location.locations)) {
          const ids = location.locations.map(l => l.true_id).filter(Boolean)
          for (const id of ids) {
            url += `&externalLocationId=${encodeURIComponent(id)}`
          }
        } else if (location.id) {
          if (location.true_id) {
            url += `&externalLocationId=${encodeURIComponent(location.true_id)}`
          }
          // if (location.inv_fiscal_code) {
          //   url += `&vatNumber=${encodeURIComponent(location.inv_fiscal_code)}`
          // }
        }
      } else {
        const allLocations = this.groupedLocations.flatMap(group => group.locations)
        const ids = allLocations.map(l => l.true_id).filter(Boolean)
        for (const id of ids) {
          url += `&externalLocationId=${encodeURIComponent(id)}`
        }
      }

      clearTimeout(this.loadingTimeout)
      this.loadingTimeout = setTimeout(() => {
        this.loading = true
      }, 100)
      try {
        const response = await fetch(url)
        const data = await response.json()
        if (Array.isArray(data.documents)) {
          clearTimeout(this.loadingTimeout)
          this.loading = false
          this.totalItems = data.total || 0
          this.currentPage = data.currentPage || page
          this.pageSize = data.pageSize || pageSize
          this.tableData = data.documents.map(invoice => {
            let vatValue = 0
            if (invoice.vatTotals && typeof invoice.vatTotals === 'object') {
              vatValue = Object.values(invoice.vatTotals).reduce((sum, val) => sum + val, 0)
            }

            return {
              id: invoice._id || invoice.id,
              invoiceNumber: invoice.invoiceNumber,
              client: invoice.customer ? invoice.customer.name : 'N/A',
              issueDate: invoice.date,
              valueNoVAT: (invoice.subtotal).toFixed(2) + ' ' + invoice.currency,
              vatValue: vatValue.toFixed(2) + ' ' + invoice.currency,
              totalValue: (invoice.total).toFixed(2) + ' ' + invoice.currency,
              status: 'Paid',
              series: invoice.series || 'N/A',
              hasParent: !!invoice.parentDocument
            }
          })
        } else {
          console.error('Invalid data format:', data)
          this.loading = false
        }
      } catch (error) {
        console.error('Error fetching invoices:', error)
        this.loading = false
      }
    },
    applyFilter () {
      this.getInvoices(this.filter.series)
      this.$modal.hide('filterModal')
    },
    clearFilter () {
      this.filter.series = ''
      this.getInvoices()
      this.$modal.hide('filterModal')
    },
    async downloadExcel (row) {
      const series = row.series
      const invoiceNumber = row.invoiceNumber
      const externalCompanyId = this.companyID

      if (!series || !invoiceNumber || !externalCompanyId) {
        alert('Missing series, invoice number or company ID.')
        return
      }

      const url = `${process.env.API_BASE_URL_GESTIUNE}:4443/aviz/${series}-${invoiceNumber}/xls?externalCompanyId=${externalCompanyId}`

      try {
        const response = await fetch(url)
        if (response.ok) {
          const blob = await response.blob()
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = `${series}-${invoiceNumber}.xls`
          link.click()
          URL.revokeObjectURL(link.href)
        } else {
          console.error('Error downloading invoice:', response.statusText)
        }
      } catch (error) {
        console.error('Error fetching invoice:', error)
      }
    },
    async downloadInvoice (row) {
      const series = row.series
      const invoiceNumber = row.invoiceNumber
      const externalCompanyId = this.companyID

      if (!series || !invoiceNumber) {
        alert('Missing series or invoice number.')
        return
      }

      const url = `${process.env.API_BASE_URL_GESTIUNE}:4443/aviz/${series}-${invoiceNumber}/pdf?externalCompanyId=${externalCompanyId}`

      try {
        const response = await fetch(url)
        if (response.ok) {
          const blob = await response.blob()
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = `${series}-${invoiceNumber}.pdf`
          link.click()
          URL.revokeObjectURL(link.href)
        } else {
          console.error('Error downloading invoice:', response.statusText)
        }
      } catch (error) {
        console.error('Error fetching invoice:', error)
      }
    },
    async handleDeleteInvoice (id) {
      console.log(id)
      if (!id) {
        console.error('Missing Invoice ID for deletion.')
        return
      }

      swal({
        title: 'Ești sigur?',
        text: 'Această acțiune va șterge definitiv factura!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Da, șterge!',
        cancelButtonText: 'Anulează'
      }).then(async (result) => {
        if (result) {
          try {
            const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/remove`, {
              method: 'DELETE',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                type: 'aviz',
                id: id,
                externalCompanyId: this.companyID
              })
            })

            if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`)

            const data = await response.json()
            console.log('Invoice deleted successfully:', data)

            swal({
              title: 'Succes!',
              text: 'Avizul a fost șters cu succes.',
              type: 'success',
              timer: 2000,
              showConfirmButton: false
            })

            this.getInvoices()
          } catch (error) {
            console.error('Error deleting Invoice:', error)

            swal({
              title: 'Eroare!',
              text: 'A apărut o problemă la ștergerea avizului.',
              type: 'error',
              timer: 2000,
              showConfirmButton: false
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.tableInvoice .el-table .cell {
  height: 90px;
}
.action-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center; /* Aliniază butoanele pe axa verticală */
  margin-bottom: 15px;
}

.left-buttons {
  display: flex;
  align-items: center;
}
.edit i {
  margin-right: 0px !important;
}
.left-buttons button{
  display: flex;
  align-items: center;
  padding-top: 10px;
}
.downl {
  background: green !important;
  max-width: fit-content !important;
}
.left-buttons el-button {
  margin-right: 10px; /* Spațiere între butoane */
}

.right-button {
  margin-left: auto; /* Asigură că butonul "Editare Multipla" se aliniază la dreapta */
}

.button-group {
  display: flex; /* Folosește flexbox pentru alinierea orizontală */
  justify-content: flex-end; /* Aliniază butoanele la dreapta */
}
.button-group .btn {
    margin-right: 10px; /* Adaugă un spațiu între butoane */
}
.button-group .btn:last-child {
    margin-right: 0; /* Elimină marginea dreaptă pentru ultimul buton */
}
.arrow-box {
  display: inline-block;
  font-size: 18px; /* mărimea săgeții */
  padding: 4px 6px;
  border: 1px solid #674BD2 !important; /* border violet */
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  user-select: none;
  transition: background-color 0.2s, border-color 0.2s, color 0.2s;
  color: #674BD2; /* culoarea săgeții */
}

.arrow-box:hover {
  background-color: #674BD2 !important;
  border-color: #674BD2 !important;
  color: #fff !important; /* săgeata albă la hover */
}

/* Dropdown menu */
.custom-dropdown-menu {
  min-width: 180px;
  font-size: 14px;
}
.el-pagination {
  text-align: center !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/Outputs/ManagementAviz.vue